import AnswerResponse from '@/domain/survey/entity/answer-response.entity';
import PersonalityResult from './personality-result.entity';

export default class CandidatePersonalityResult {
  surveyAnswerId: string;

  startedDate: string;

  concludedDate: string;

  results: PersonalityResult[];

  answers: AnswerResponse[];

  constructor(obj: any = {}) {
    this.surveyAnswerId = obj.surveyAnswerId || '';
    this.startedDate = obj.startedDate || '';
    this.concludedDate = obj.concludedDate || '';
    this.results = obj.results || [];
    this.answers = obj.answers || [];
  }
}
